import {
	Box,
	Dialog,
	DialogTitle, LinearProgress, styled,
} from "@mui/material" 
import {useDispatch, useSelector} from "react-redux"
import {
	closeAttachmentModal,
	selectNote,
	selectIsModalOpen,
	selectActionType,
	selectIsSubmitting
} from "../../../../../reducers/noteAttachmentsSlice"
import {LinkAttachmentModalBody} from "./NoteAttachmentModalBodies/LinkAttachmentModalBody"
import {DocAttachmentModalBody} from "./NoteAttachmentModalBodies/DocAttachmentModalBody"
import {FileAttachmentModalBody} from "./NoteAttachmentModalBodies/FileAttachmentModalBody"
import {useWorkspaceContext} from "../../../../../pages/Dashboard"

export const AttachmentLoadingIndicator = styled(LinearProgress)(({ theme }) => ({
	height: "16px",
	backgroundColor: theme.palette.primary.transparency50,
}))

export default function NoteAttachmentModal() {
	const dispatch = useDispatch()
	const { workspaceId } = useWorkspaceContext()
	const note = useSelector((state) => selectNote(state, workspaceId))
	const open = useSelector((state) => selectIsModalOpen(state, workspaceId))
	const actionType = useSelector((state) => selectActionType(state, workspaceId))
	const isSubmitting = useSelector((state) => selectIsSubmitting(state, workspaceId))
	return (
		<Dialog
			open={open}
			onClose={() => dispatch(closeAttachmentModal(workspaceId))}
			sx={{ textAlign: "left"}}
		>
			<Box sx={{
				width: "600px", // this is arbitrary and probably shouldn't be? IDK...
				overflowX: "hidden", // on FF, the addition of a scrollbar for overflow Y can trigger an overflow on the X axis.
			}}>
				{isSubmitting && ( <AttachmentLoadingIndicator /> )}
				<DialogTitle
					sx={{
						paddingTop: isSubmitting ? 0 : "16px", // 16px is MUI default for component
					}}
				>
					{actionType === "create-link" && ("Attach External Link")}
					{actionType === "edit-link" && ("Edit Link")}
					{actionType === "create-doc" && ("Create New Document")}
					{actionType === "edit-doc" && ("Edit Document Title")}
					{actionType === "create-file" && ("Upload and Attach External File")}
					{actionType === "edit-file" && ("Modify or Replace Attached File")}
				</DialogTitle>
				{ ["create-link", "edit-link"].includes(actionType) && ( <LinkAttachmentModalBody note={note}/> )}
				{ ["create-doc", "edit-doc"].includes(actionType) && ( <DocAttachmentModalBody note={note}/> )}
				{ ["create-file", "edit-file"].includes(actionType) && ( <FileAttachmentModalBody note={note}/> )}
			</Box>
		</Dialog>
	)
}
